import { Card, Button, Dropdown } from 'react-bootstrap';
import { IDataTableColumn } from '../../common/types/dataTable';
import DataTable from '../../common/components/DataTable';
import { data } from './data/standingInstructionTable';
import { useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../template/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dataTableBgImg from '../../../../src/assets/img/illustrations/cornerRight-1.png';
import {
  faCheckCircle,
  faGear,
  faPlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  Outlet,
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import InstructionForm from './InstructionForm';
import { Link } from 'react-router-dom';
import FilterView from '../../common/components/FilterView';
import Header from '../../common/components/DetailsViewHeader';
import queryString from 'query-string';
import { updateBackNavUrl } from '../../common/slices/documentViewSlice';
import { useDispatch } from 'react-redux';
import {
  IConfigsDefinition,
} from '../../utils/columnConfig';
import { updateCurrentPageStandingInst } from '../dashboard/slices/dashboardSlice';
import {
  toggleColumnSettingsDashboard,
  updateRowColumns,
} from './slices/standingInstructionTable';
import quieryString from 'query-string';
import { updateDashbaordName } from '../../common/slices/navbarTop';
import { getColumnViews } from '../../common/actions/dataTable';
import { updateDashbaordRefresh, updateParams } from '../../common/components/DataTable/slices/DataTable';
import { AESDecrypt, AESDecryptAny, AESEncrypt } from '../../../encrypt-util';
import { getUnprefixedPathname } from '../../../helpers/utils';
import { getDashboardData } from '../dashboard/actions/dashboard';
import OdexSpinner from '../../common/components/OdexSpinner';
import { updateInstructionID } from '../blDetails/slices/documentHistorySlice';
import { useAmountFormatter } from '../../../hooks/useAmountFormatter';
import { useGenerateColumnConfig } from '../../../hooks/useGenerateColumnConfig';
import DashboardContainer from '../../../components/common/DashboardContainer';

const dashboarName = 'STANDING_INSTRUCTION';
const uniqueFilterKey = 'standingInst';
const defaultSort = 'standing_instruction_id desc';

const StandingInstructionTable = () => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const navigate = useNavigate();
  const { userID, encryptdoc } = useParams();

  const [previousState, setPreviousState] = useState<{
    filterState: string | null;
    search: string | null;
    grids: any[] | null;
  }>({ filterState: null, search: null, grids: null });

  const [configs, setConfigs] = useState<IConfigsDefinition>({
    columns: [],
    staticHiddenCols: [],
    defaultHiddenCols: [],
  });
  const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const onDashboard = location.pathname === `${APP_PATH_PREFIX}/standing`;
  const rowColumns = {
    mainTableClass: onDashboard ? 'col-lg-12' : 'col-lg-3',
    outletClass: onDashboard ? 'd-none' : 'col-lg-9',
  };

  const [columns, setColumns] = useState<IDataTableColumn[]>([]);
  const standingInstructionDetails = useSelector(
    (state: RootState) => state.standingInstructionList
  );
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const showColumnSettings = useSelector(
    (state: RootState) => state.standingInstructionList.showColumnSettings
  );
  const sortState = useSelector((state:RootState) => state.dataTable.sortState);
  const dataLoading = useSelector(
    (state: RootState) => state.standingInstructionList.dataLoading
  );
  const loading = useSelector(
    (state: RootState) => state.dashboard.dataLoading
  );
  const refresh = useSelector(
    (state: RootState) => state.dataTable.refreshDashboard
  );
  const grids = useSelector(
    (state: RootState) => state.dataTable.standingInstructionGrids
  );

  const data = useSelector(
    (state: RootState) => state.dashboard.standingInstructionList
  );
  const filterState = useSelector(
    (state: RootState) => state.dataTable.filterState
  );

  const currentPageStandingInst = useSelector(
    (state: RootState) => state.dashboard.currentPageStandingInst
  );

  const selectedTopSearchFilter = useSelector(
    (state: RootState) => state.navbarTop.selectedTopSearchFilter
  );
  const searchInputValue = useSelector(
    (state: RootState) => state.navbarTop.searchInputValue
  );
  const standingInstSearchState = useSelector(
    (state: RootState) => state.navbarTop.standingInstSearchState
  );

  const loadingGridConfigs = useSelector(
    (state: RootState) => state.dataTable.loadingGridConfigs
  );

  function useDebouncedEffect(effect: any, deps: any, delay: any) {
    const callback = useRef<any>();
    
    useEffect(() => {
      callback.current = effect;
    }, [effect]);
  
    useEffect(() => {
      const handler = () => {
        if (callback.current) {
          callback.current();
        }
      };
  
      const timer = setTimeout(handler, delay);
      
      return () => clearTimeout(timer);
    }, [...deps, delay]);
  }

  const setCurrentPage = (page: number) => {
    dispatch(updateCurrentPageStandingInst(page));
  };

  const onHideColumnSettings = () => {
    dispatch(toggleColumnSettingsDashboard(false));
  };

  const getParams = () => {
		console.log('getParams called, pathname:', getUnprefixedPathname());
		console.log('decrypted instruction ID:', AESDecrypt(getUnprefixedPathname().split('/')[4]));
    dispatch(
      updateInstructionID(AESDecrypt(getUnprefixedPathname().split('/')[4]))
    );
    return { standing_instruction_id: AESDecrypt(encryptdoc) };
  };

  const filterStateLocal = filterState?.[uniqueFilterKey];
  const sort = (quieryString.parse(location.search)?.sort as string)
    ?.split(',')
    ?.join(' ');

  const generateColumnConfig = useGenerateColumnConfig()

  useEffect(() => {
    const standingInstDefinition = grids?.[0]?.columnConfigGrid || '';
    if (!standingInstDefinition) return;

    try {
      const configs = generateColumnConfig(
        JSON.parse(JSON.parse(standingInstDefinition)),
        getParams,
      );

      const columns = configs?.columns?.map((c) => c);
      setConfigs(configs);
      setColumns(columns);
    } catch (e) {
      console.error('Column Error: ', e);
    }
  }, [grids, location]);

  // Getting the user country
  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );
  const storedUserCountry =
    AESDecryptAny(window.localStorage.getItem('@user-selected-datacountry')) || [];
  const storedCountry =
    storedUserCountry?.[0]?.loginId === profileDetails.email
      ? storedUserCountry?.[0]?.country
      : null;
  const dataCountry =
    storedCountry ?? linerDataCountry ?? profileDetails.partnerCountry ?? null;
    const linerId = useSelector((state: RootState) => state.navbarTop.linerId);
  const language = useSelector((state: RootState) => state.navbarTop.language);
  useEffect(() => {
    dispatch(updateDashbaordName(dashboarName));
  }, []);

 /*  useEffect(() => {
    if (
      matchPath(
        '/standing/:blNum/:encrypt/:standing_instruction_id',
        location.pathname
      ) ||
      matchPath(`${APP_PATH_PREFIX}/standing/:encrypt`, location.pathname)
    ) {
      dispatch(
        updateRowColumns({
          mainTableClass: 'col-lg-3',
          outletClass: 'col-lg-9',
        })
      );
    } else {
      dispatch(
        updateRowColumns({
          mainTableClass: 'col-lg-12',
          outletClass: 'd-none',
        })
      );
    }
  }, [location.pathname]); */

  useEffect(() => {
    if (dataCountry && linerId) {
      dispatch(
        getColumnViews({ gridName: dashboarName, country: dataCountry, linerId : linerId, language: language || localStorage.getItem('selectedLanguage') || 'EN' })
      );
    }
    dispatch(updateParams({}));
  }, [dataCountry, linerId, language]);

  useEffect(() => {
    if (refresh) loadStandingDashboard(false);
    // server sometimes takes time to update the view so the delay
    setTimeout(() => dispatch(updateDashbaordRefresh(false)), 2000);
  }, [refresh]);
  const selectedPort = useSelector((state:RootState) => state.userProfile.selectedPort);
  useEffect(() => {
    loadStandingDashboard(false);
  }, [currentPageStandingInst, selectedPort]);

  // useEffect(() => {
  //   loadStandingDashboard(true);
  // }, [location.pathname, dataCountry, linerId]);

   /* useDebouncedEffect(() => {
    loadStandingDashboard(true);
  }, [location.pathname,dataCountry, linerId], 700);
 */
   useEffect(() => {
    const currentStateValue = {
      filterState: JSON.stringify(filterStateLocal),
      search: location.search,
      grids: grids,
    };

    if (JSON.stringify(previousState) !== JSON.stringify(currentStateValue)) {
      loadStandingDashboard(true);
      setPreviousState(currentStateValue);
    }
  }, [filterStateLocal, location.search, grids, linerId]);

  useEffect(() => {
    loadStandingDashboard(true);
  }, [language]);

  const loadStandingDashboard = (filterUpdated: boolean) => {
  
    if (filterUpdated) setCurrentPage(1);

    if (filterStateLocal) {
      if (Object.keys(filterStateLocal)?.length > 0) {
        const filterApiState: any = {};
        const filterKeys = Object.keys(filterStateLocal);

        for (let k of filterKeys) {
          if (filterStateLocal?.[k]?.from) {
            filterApiState[k] = [
              filterStateLocal?.[k]?.from || '',
              filterStateLocal?.[k]?.to || '',
            ].filter((i) => i);
          } else if (filterStateLocal?.[k]?.from !== undefined) {
            filterApiState[k] = undefined;
          } else {
            filterApiState[k] = filterStateLocal?.[k]
              ? typeof filterStateLocal?.[k] === 'string'
                ? [filterStateLocal?.[k]]
                : filterStateLocal?.[k]
              : undefined;
          }
        }
        if (Object.keys(filterApiState)?.length > 0) {
          const finalFilterApiState: any = {};

          for (let i of Object.keys(filterApiState)) {
            if (filterApiState[i]) {
              finalFilterApiState[i] = filterApiState[i];
            }
          }
          if (
            (profileDetails.partnerType === 'customer' &&
              profileDetails.partnerId &&
              grids?.[0]?.whereClause) ||
            profileDetails.partnerType === 'liner'
          ) {
            setTimeout(()=>{dispatch(
              getDashboardData({
                v2:true,
                gridName: dashboarName,
                payload: {
                  fields: /*  SelectedViewFields?.fields || */ [],
                  filters: finalFilterApiState ?? {},
                  size: 20,
                  sorts: sortState && sortState?.key!=null && sortState?.value!=null ? [`${sortState?.key} ${sortState?.value}`] : sort ? [sort] : [defaultSort],
                  page: currentPageStandingInst,
                },
                dataCountry: dataCountry,
                partnerId:
                  profileDetails.partnerType === 'customer'
                    ? profileDetails.partnerId
                    : null,
                where: grids?.[0]?.whereClause
                  ? AESEncrypt(grids?.[0]?.whereClause)
                  : null,
                parameter:
                  selectedTopSearchFilter?.where !== ''
                    ? {
                        searchParameter: searchInputValue,
                        searchWhere: selectedTopSearchFilter?.where,
                      }
                    : {},
              })
            );},250)
            
          }
        }
      } else if (
        (profileDetails.partnerType === 'customer' &&
          profileDetails.partnerId &&
          grids?.[0]?.whereClause) ||
        profileDetails?.partnerType === 'liner'
      ) {
        setTimeout(()=>{dispatch(
          getDashboardData({
            v2:true,
            gridName: dashboarName,
            payload: {
              fields: /* SelectedViewFields?.fields || */ [],
              filters:
                selectedTopSearchFilter?.where === ''
                  ? standingInstSearchState
                  : {},
              size: 20,
              sorts: sortState && sortState?.key!=null && sortState?.value!=null ? [`${sortState?.key} ${sortState?.value}`] : sort ? [sort] : [defaultSort],
              page: currentPageStandingInst,
            },
            dataCountry: dataCountry,
            partnerId:
              profileDetails.partnerType === 'customer'
                ? profileDetails.partnerId
                : null,
            where: grids?.[0]?.whereClause
              ? AESEncrypt(grids?.[0]?.whereClause)
              : null,
            parameter:
              selectedTopSearchFilter?.where !== ''
                ? {
                    searchParameter: searchInputValue,
                    searchWhere: selectedTopSearchFilter?.where,
                  }
                : {},
          })
        );},250)
        
      }
    } else if (
      !location.pathname.includes('blsliderinvoice/') &&
      location.pathname.includes('/payment') &&
      location?.state?.from == undefined
    ) {
      if (
        (profileDetails.partnerType === 'customer' &&
          profileDetails.partnerId &&
          grids?.[0]?.whereClause) ||
        profileDetails.partnerType === 'liner'
      ) {
        setTimeout(()=>{dispatch(
          getDashboardData({
            v2:true,
            gridName: dashboarName,
            payload: {
              fields: /* SelectedViewFields?.fields || */ [],
              filters:
                selectedTopSearchFilter?.where == ''
                  ? standingInstSearchState
                  : {},
              size: 20,
              sorts: sortState && sortState?.key!=null && sortState?.value!=null ? [`${sortState?.key} ${sortState?.value}`] : sort ? [sort] : [defaultSort],
              page: currentPageStandingInst,
            },
            dataCountry: dataCountry,
            partnerId:
              profileDetails.partnerType === 'customer'
                ? profileDetails.partnerId
                : null,
            where: grids?.[0]?.whereClause
              ? AESEncrypt(grids?.[0]?.whereClause)
              : null,
            parameter:
              selectedTopSearchFilter?.where !== ''
                ? {
                    searchParameter: searchInputValue,
                    searchWhere: selectedTopSearchFilter?.where,
                  }
                : {},
          })
        );},250)
        
      }
    }
  };
  const sideWidth = useMemo(
    () =>
      Object.entries({
        [`${APP_PATH_PREFIX}/standing`]: 0,
      }).find(([path, _]) => matchPath(path, location.pathname))?.[1] ?? 9,
    [location.pathname]
  );
  
  return (
    <DashboardContainer
      sideWidth={sideWidth}
      inner={false}
      innerOffset={0}
      middleScroll={false}
    >
        <Card.Body className='p-0 h-100'>
                        <FilterView
                          loadList={loadStandingDashboard}
                          showColumnSettings={location.pathname === `${APP_PATH_PREFIX}/standing`}
                          showRightDiv={location.pathname === `${APP_PATH_PREFIX}/standing`}
                          toggleColumnSettings={toggleColumnSettingsDashboard}
                          configViews={
                            grids?.find?.((g) => g?.gridName === dashboarName)
                              ?.configGroup || []
                          }
                          showExport={location.pathname === `${APP_PATH_PREFIX}/standing`}
                          uniqueFilterKey={uniqueFilterKey}
                          data={data}
                          columns={columns}
                          dataLoading={dataLoading}
                          columnSettingsPersistKey='@odex/user/v1'
                          dashboardName={dashboarName}
                          gridDef={grids}
                          showAddInstruct={location.pathname === `${APP_PATH_PREFIX}/standing`}
                        />
                        {columns?.length > 0 && (
                        <DataTable
                          data={data?.result || null}
                          columns={columns}
                          dataCountry={dataCountry || ''}
                          gridName={dashboarName}
                          sortable
                          searchable={false}
                          showColumnFilter={false}
                          selection={false}
                          perPage={20}
                          hasNext={data?.hasNext}
                          currentPage={currentPageStandingInst}
                          gridId={grids?.[0]?.gridId || 0}
                          onChangePageNumber={(pageNumber) =>
                            setCurrentPage(pageNumber)
                          }
                          pagination
                          showExport={false}
                          showColumnSettings={showColumnSettings}
                          onHide={onHideColumnSettings}
                          uniqueFilterKey={uniqueFilterKey}
                          staticHiddenCols={configs?.staticHiddenCols || []}
                          tableMinHeight={400}
                          dataLoading={false}
                          customSort={true}
                          numberPagination
                          previous={
                            standingInstructionDetails?.data?.instructionData
                              ?.previous || ''
                          }
                          next={
                            standingInstructionDetails?.data?.instructionData
                              ?.next || ''
                          }
                          shortPrepend='stanfing_'
                          defaultHiddenCols={configs?.defaultHiddenCols || []}
                          configGroup={
                            grids?.find?.(
                              (g) => g?.gridName === 'STANDING_INSTRUCTION'
                            )?.configGroup || []
                          }
                        />
                        )}
        </Card.Body>
    </DashboardContainer>
  );
};

export default StandingInstructionTable;
